import { PDFForm, PDFTextField } from 'pdf-lib';

export const safeSetTextField = (form: PDFForm, fieldName: string, value: string | undefined | null): void => {
  if (value == null || value === '') return;
  let field: PDFTextField;
  try {
    field = form.getTextField(fieldName);
  } catch {
    return;
  }
  const maxLength = field.getMaxLength();
  let toSet = String(value);
  if (maxLength != null && toSet.length > maxLength) {
    const digitsOnly = toSet.replace(/\D/g, '');
    if (digitsOnly.length > 0 && digitsOnly.length <= maxLength) {
      toSet = digitsOnly;
    } else if (digitsOnly.length > maxLength) {
      toSet = digitsOnly.slice(0, maxLength);
    } else {
      toSet = toSet.slice(0, maxLength);
    }
  }
  try {
    field.setText(toSet);
    field.enableReadOnly();
  } catch (e) {
    console.error(`[pdfFieldHelpers] Failed to set field "${fieldName}":`, e);
  }
};
